import 'rg4js';
import React from 'react';
import ReactDOM from 'react-dom';
import injectTapEventPlugin from 'react-tap-event-plugin';
import {Provider} from 'react-redux';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import {applyMiddleware, createStore, combineReducers} from 'redux';
import {reducer as formReducer} from 'redux-form';
import thunk from 'redux-thunk';
import {composeWithDevTools} from 'redux-devtools-extension';
import * as reducers from './reducers';
import fileUploader from './middleware/fileUploader';
import AuthenticationWrapper from './containers/AuthenticationWrapper/AuthenticationWrapper';
import LoginContainer from './containers/LoginContainer/LoginContainer';
import DemoRedirectContainer from './containers/DemoRedirectContainer/DemoRedirectContainer';
import ActivationContainer from './containers/ActivationContainer/ActivationContainer';
import NotificationContainer from './containers/NotificationContainer/NotificationContainer';
import {unregister as registerServiceWorker} from './registerServiceWorker';
import './styles/imports/imports.scss';
import './styles/box.css';
import './styles/content.css';
import './styles/page.css';
import './styles/label.css';
import './styles/ribbon.css';
import './styles/forms.css';
import './styles/entity-item.css';
import './index.css';

injectTapEventPlugin();

const store = createStore(
  combineReducers({...reducers, form: formReducer}),
  composeWithDevTools(
    applyMiddleware(thunk, fileUploader)
  ));

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <div>
        <NotificationContainer />
        <Switch>
          <Route
            path="/login"
            exact={true}
            component={LoginContainer} />
          <Route
            path="/activate/:token"
            exact={true}
            render={({match: {params}}) => (
              <ActivationContainer
                token={params.token} />
            )} />
          <Route
            path="/demo/:projectName"
            exact={true}
            render={({match: {params}})  => (
              <DemoRedirectContainer
                projectName={params.projectName} />
            )} />
          <Route component={AuthenticationWrapper} />
        </Switch>
      </div>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);

if (process.env.NODE_ENV === 'production') {
  Raygun.init(process.env.REACT_APP_RAYGUNAPIKEY)
    .attach()
    .withTags(['frontend'])
    .setVersion(process.env.REACT_APP_VERSION);
}

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js